// extracted by mini-css-extract-plugin
module.exports = {"container":"cornerOwned_container___Lab0","ribbon":"cornerOwned_ribbon__03VDQ"};